import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { AddressFormModule } from '@vendasta/businesses';
import { GalaxyWrapModule } from '@vendasta/galaxy/galaxy-wrap';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { WEBLATE_COMPONENT_NAME } from '@vendasta/store';
import baseTranslation from '../../assets/i18n/en_devel.json';
import { CompanyProfileApiService } from './company-profile-api.service';
import { CompanyProfileComponent } from './company-profile.component';
import { CompanyProfileService } from './company-profile.service';

@NgModule({
  imports: [
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatTooltipModule,
    CommonModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatOptionModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    RouterModule,
    GalaxyPageModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    GalaxyWrapModule,
    AddressFormModule,
    GalaxyInputModule,
  ],
  exports: [CompanyProfileComponent],
  declarations: [CompanyProfileComponent],
  providers: [CompanyProfileService, CompanyProfileApiService],
})
export class PartnerModule {}
